<template>
  <div :class="{ our_serve: isshow, our_serve2: !isshow }">
    <h2 class="title" v-if="isshow">我们的服务 Our Services</h2>
    <ul v-if="isshow" class="one">
      <li>
        <div>
          <p @click="toPro('#one')">
            <img :src="require('@img/home/gh.png')" alt="" />
            <span>综合规划专业</span>
          </p>
        </div>
        <div>
          <p @click="toPro('#two')">
            <img :src="require('@img/home/ql.png')" alt="" />
            <span>交通设计专业</span>
          </p>
        </div>
      </li>
      <li>
        <div>
          <p @click="toPro('#three')">
            <img :src="require('@img/home/cj.png')" alt="" />
            <span>城建设计专业</span>
          </p>
        </div>
        <div>
          <p @click="toPro('#four')">
            <img :src="require('@img/home/gc.png')" alt="" />
            <span>工程管理</span>
          </p>
        </div>
      </li>
      <li>
        <div>
          <p @click="toPro('#five')">
            <img :src="require('@img/home/gcjsyj.png')" alt="" />
            <span>工程技术研究</span>
          </p>
        </div>
      </li>
    </ul>
    <ul v-if="!isshow" class="two">
      <li v-for="(item, id) in list" :key="id" @click="toPro(item.id)">
        <img :src="item.img" alt="" />
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "our-serve",
  props: {
    serve_style: {
      type: String,
      default: "2",
    },
  },
  data() {
    return {
      list: [
        {
          img: require("@img/home/gh.png"),
          name: "综合规划",
          id: "#one",
        },
        {
          img: require("@img/home/ql.png"),
          name: "交通设计",
          id: "#two",
        },
        {
          img: require("@img/home/cj.png"),
          name: "城建设计",
          id: "#three",
        },
        {
          img: require("@img/home/gc.png"),
          name: "工程管理",
          id: "#four",
        },
        {
          img: require("@img/home/gcjsyj.png"),
          name: "工程技术",
          id: "#five",
        },
      ],
    };
  },
  components: {},
  computed: {
    isshow() {
      return this.serve_style == 1;
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 跳转到我们的服务具体位置
    toPro(id) {
      this.$router.push({ path: "/ourservices/project", query: { id } });
    },
  },
};
</script>
<style scoped lang='less'>
@width: 80%;
.ani {
  transition: all 0.3s linear;
}
.our_serve {
  height: 600px;
  width: 100%;
  position: relative;
}
.our_serve2 {
  height: 200px;
  width: 100%;
  position: relative;
}

.one {
  width: @width;
  margin: 0 auto;
  li {
    height: 150px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    div {
      width: 50%;
      height: 60px;
      display: flex;
      align-items: center;
      // justify-content: center;
      p {
        width: 300px;
        display: flex;
        cursor: pointer;
        &:hover img {
          transform: scale(1.2);
        }
      }
      img {
        width: 60px;
        height: 60px;
        .ani();
        transform: scale(1.1);
      }
      span {
        font-size: 20px;
        align-self: flex-end;
        padding-left: 50px;
        padding-bottom: 5px;
      }
    }
  }
}
.two {
  width: 1500px;
  height: 300px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  li {
    width: 25%;
    height: 200px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: space-around;
    cursor: pointer;
    img {
      width: 60px;
      height: 60px;
      .ani();
      transform: scale(1.1);
    }
    span {
      font-size: 20px;
      padding-bottom: 5px;
    }
  }
}
.title {
  font-size: 32px;
  text-align: center;
  font-weight: 600;
  line-height: 180px;
  font-weight: 600;
  color: @baseTitle;
  color: #333333;
}
@media screen and (max-width: @mbwidth) {
  .f() !important;
  .mb_title() !important;
  .our_serve {
    height: 260px;
  }
}
.f {
  ul {
    // width: 100%;
    li {
      height: 60px;
    }
  }
  .one li div {
    width: 46%;
  }
  p {
    // width: 80%;
    width: 100%;
    align-items: center;
    justify-content: space-around;
  }
  img {
    width: 30px;
    height: 30px;
    transform: scale(1);
  }
  .one {
    span {
      width: 80%;
      font-size: 12px;
      align-self: center;
      padding-bottom: 0;
      padding-left: 0;
      .oversl(1);
      // text-align: center;
      padding-left: 24px;
    }
  }

  .two {
    height: 150px;
    width: 80%;
    li {
      height: 90px;
      width: 20%;
      img {
        margin-bottom: 30px;
      }
      span {
        width: 80%;
        font-size: 12px;
        align-self: center;
        padding-bottom: 0;
        padding-left: 0;
        // .oversl(1);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .our_serve2 {
    height: 80px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/our_server/index.vue